// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1cSVd","header":"ReportDetails_header__3TWfz","title":"ReportDetails_title__1f2Vg","left":"ReportDetails_left__3nIeC"};